module.exports = __webpack_public_path__ + "static/media/edit_constraints_course_teachers.dbe429ba.mov";